import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
//模板管理
export function queryDocTemplate(_x) {
  return _queryDocTemplate.apply(this, arguments);
}
function _queryDocTemplate() {
  _queryDocTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request("/docTemp/queryDocTemplate", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryDocTemplate.apply(this, arguments);
}
export function changeTemplateStatus(_x2) {
  return _changeTemplateStatus.apply(this, arguments);
}
function _changeTemplateStatus() {
  _changeTemplateStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request("/docTemp/changeTemplateStatus", METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _changeTemplateStatus.apply(this, arguments);
}
export function updateTempScope(_x3) {
  return _updateTempScope.apply(this, arguments);
}
function _updateTempScope() {
  _updateTempScope = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request("/docTemp/updateTempScope", METHOD.POST, data));
      }
    }, _callee3);
  }));
  return _updateTempScope.apply(this, arguments);
}
export function getDocTempScope(_x4) {
  return _getDocTempScope.apply(this, arguments);
}
//发文管理
function _getDocTempScope() {
  _getDocTempScope = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request("/docTemp/getDocTempScope", METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _getDocTempScope.apply(this, arguments);
}
export function queryDocTempAvailable(_x5) {
  return _queryDocTempAvailable.apply(this, arguments);
}
function _queryDocTempAvailable() {
  _queryDocTempAvailable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request("/docSendMgr/queryDocTempAvailable", METHOD.POST, data));
      }
    }, _callee5);
  }));
  return _queryDocTempAvailable.apply(this, arguments);
}
export function addDocumentFill(_x6) {
  return _addDocumentFill.apply(this, arguments);
}
function _addDocumentFill() {
  _addDocumentFill = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request("/docSendMgr/addDocumentFill", METHOD.POST, data));
      }
    }, _callee6);
  }));
  return _addDocumentFill.apply(this, arguments);
}
export function getDocumentFillByAuth(_x7) {
  return _getDocumentFillByAuth.apply(this, arguments);
}
function _getDocumentFillByAuth() {
  _getDocumentFillByAuth = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(data) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, request("/docSendMgr/getDocumentFillByAuth", METHOD.POST, data));
      }
    }, _callee7);
  }));
  return _getDocumentFillByAuth.apply(this, arguments);
}
export function getDocumentFillDataById(_x8) {
  return _getDocumentFillDataById.apply(this, arguments);
}
function _getDocumentFillDataById() {
  _getDocumentFillDataById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(data) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request("/docSendMgr/getDocumentFillDataById", METHOD.POST, data));
      }
    }, _callee8);
  }));
  return _getDocumentFillDataById.apply(this, arguments);
}
export function editDocumentFillById(_x9) {
  return _editDocumentFillById.apply(this, arguments);
}
function _editDocumentFillById() {
  _editDocumentFillById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(data) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request("/docSendMgr/editDocumentFillById", METHOD.POST, data));
      }
    }, _callee9);
  }));
  return _editDocumentFillById.apply(this, arguments);
}
export function documentFillSubmit(_x0) {
  return _documentFillSubmit.apply(this, arguments);
}
function _documentFillSubmit() {
  _documentFillSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(data) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, request("/docSendMgr/documentFillSubmit", METHOD.POST, data));
      }
    }, _callee0);
  }));
  return _documentFillSubmit.apply(this, arguments);
}
export function saveDocumentPenPaper(_x1) {
  return _saveDocumentPenPaper.apply(this, arguments);
}
function _saveDocumentPenPaper() {
  _saveDocumentPenPaper = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(data) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request('/docSendMgr/saveDocumentPenPaper', METHOD.POST, data));
      }
    }, _callee1);
  }));
  return _saveDocumentPenPaper.apply(this, arguments);
}
export function saveDocumentResult(_x10) {
  return _saveDocumentResult.apply(this, arguments);
}
function _saveDocumentResult() {
  _saveDocumentResult = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(data) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request('/docSendMgr/saveDocumentResult', METHOD.POST, data));
      }
    }, _callee10);
  }));
  return _saveDocumentResult.apply(this, arguments);
}
export function withdrawOption(_x11) {
  return _withdrawOption.apply(this, arguments);
}
function _withdrawOption() {
  _withdrawOption = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(data) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, request("/docSendMgr/withdrawOption", METHOD.POST, data));
      }
    }, _callee11);
  }));
  return _withdrawOption.apply(this, arguments);
}
export function downloadFile(_x12) {
  return _downloadFile.apply(this, arguments);
}
function _downloadFile() {
  _downloadFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(data) {
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          return _context12.a(2, request("/docSendMgr/downloadFile", METHOD.POST, data));
      }
    }, _callee12);
  }));
  return _downloadFile.apply(this, arguments);
}
export function queryIsDelayDocument(_x13) {
  return _queryIsDelayDocument.apply(this, arguments);
}
function _queryIsDelayDocument() {
  _queryIsDelayDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(data) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request('/docSendMgr/queryIsDelayDocument', METHOD.POST, data));
      }
    }, _callee13);
  }));
  return _queryIsDelayDocument.apply(this, arguments);
}
export function documentProcess(_x14) {
  return _documentProcess.apply(this, arguments);
}
function _documentProcess() {
  _documentProcess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(data) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, request("/docSendMgr/documentProcess", METHOD.POST, data));
      }
    }, _callee14);
  }));
  return _documentProcess.apply(this, arguments);
}
export function documentFillDeleteById(_x15) {
  return _documentFillDeleteById.apply(this, arguments);
}
function _documentFillDeleteById() {
  _documentFillDeleteById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(data) {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, request("/docSendMgr/documentFillDeleteById", METHOD.POST, data));
      }
    }, _callee15);
  }));
  return _documentFillDeleteById.apply(this, arguments);
}
export function getDocumentViewRecord(_x16) {
  return _getDocumentViewRecord.apply(this, arguments);
}

//待办公文
//查询待办公文
function _getDocumentViewRecord() {
  _getDocumentViewRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(data) {
    return _regenerator().w(function (_context16) {
      while (1) switch (_context16.n) {
        case 0:
          return _context16.a(2, request("/docSendMgr/getDocumentViewRecord", METHOD.POST, data));
      }
    }, _callee16);
  }));
  return _getDocumentViewRecord.apply(this, arguments);
}
export function queryDocTodo(_x17) {
  return _queryDocTodo.apply(this, arguments);
}

//查询待办公文详情
function _queryDocTodo() {
  _queryDocTodo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(data) {
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.n) {
        case 0:
          return _context17.a(2, request("/docTodo/queryDocTodo", METHOD.POST, data));
      }
    }, _callee17);
  }));
  return _queryDocTodo.apply(this, arguments);
}
export function queryDocTodoDet(_x18) {
  return _queryDocTodoDet.apply(this, arguments);
}
function _queryDocTodoDet() {
  _queryDocTodoDet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(data) {
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          return _context18.a(2, request("/docTodo/queryDocTodoDet", METHOD.POST, data));
      }
    }, _callee18);
  }));
  return _queryDocTodoDet.apply(this, arguments);
}
export function queryTempThreeContent(_x19) {
  return _queryTempThreeContent.apply(this, arguments);
}

//审核公文
function _queryTempThreeContent() {
  _queryTempThreeContent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(data) {
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          return _context19.a(2, request("/docTodo/queryTempThreeContent", METHOD.POST, data));
      }
    }, _callee19);
  }));
  return _queryTempThreeContent.apply(this, arguments);
}
export function auditDocTodo(_x20) {
  return _auditDocTodo.apply(this, arguments);
}

//收文管理
function _auditDocTodo() {
  _auditDocTodo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(data) {
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.n) {
        case 0:
          return _context20.a(2, request("/docTodo/auditDocTodo", METHOD.POST, data));
      }
    }, _callee20);
  }));
  return _auditDocTodo.apply(this, arguments);
}
export function queryDocGatherList(_x21) {
  return _queryDocGatherList.apply(this, arguments);
}
function _queryDocGatherList() {
  _queryDocGatherList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(data) {
    return _regenerator().w(function (_context21) {
      while (1) switch (_context21.n) {
        case 0:
          return _context21.a(2, request("/docGather/queryDocGatherList", METHOD.POST, data));
      }
    }, _callee21);
  }));
  return _queryDocGatherList.apply(this, arguments);
}
export function issuedDocGather(_x22) {
  return _issuedDocGather.apply(this, arguments);
}

/**
 * 查阅情况按人员
 * 接口文档http://43.136.181.215:4999/web/#/48/2947
 */
function _issuedDocGather() {
  _issuedDocGather = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(data) {
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.n) {
        case 0:
          return _context22.a(2, request("/docGather/issuedDocGather", METHOD.POST, data));
      }
    }, _callee22);
  }));
  return _issuedDocGather.apply(this, arguments);
}
export function querySituationUser(_x23, _x24, _x25) {
  return _querySituationUser.apply(this, arguments);
}
/**
 * 查阅情况按岗位
 * 接口文档http://43.136.181.215:4999/web/#/48/2990
 */
function _querySituationUser() {
  _querySituationUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(page, limit, param) {
    var data;
    return _regenerator().w(function (_context23) {
      while (1) switch (_context23.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            mobile: param.mobile,
            query: param.query,
            docId: param.docId
          };
          return _context23.a(2, request("/docGather/querySituationUser", METHOD.POST, data));
      }
    }, _callee23);
  }));
  return _querySituationUser.apply(this, arguments);
}
export function querySituationPost(_x26, _x27, _x28) {
  return _querySituationPost.apply(this, arguments);
}
/**
 * 查阅情况按组织
 * 接口文档http://43.136.181.215:4999/web/#/48/2991
 */
function _querySituationPost() {
  _querySituationPost = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(page, limit, param) {
    var data;
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            mobile: param.mobile,
            query: param.query,
            docId: param.docId
          };
          return _context24.a(2, request("/docGather/querySituationPost", METHOD.POST, data));
      }
    }, _callee24);
  }));
  return _querySituationPost.apply(this, arguments);
}
export function querySituationOrgan(_x29, _x30, _x31) {
  return _querySituationOrgan.apply(this, arguments);
}
//公文待阅已阅
function _querySituationOrgan() {
  _querySituationOrgan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(page, limit, param) {
    var data;
    return _regenerator().w(function (_context25) {
      while (1) switch (_context25.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            mobile: param.mobile,
            query: param.query,
            docId: param.docId
          };
          return _context25.a(2, request("/docGather/querySituationOrgan", METHOD.POST, data));
      }
    }, _callee25);
  }));
  return _querySituationOrgan.apply(this, arguments);
}
export function editNewDocumentState(_x32) {
  return _editNewDocumentState.apply(this, arguments);
}
//系统通知待阅已阅
function _editNewDocumentState() {
  _editNewDocumentState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(data) {
    var id;
    return _regenerator().w(function (_context26) {
      while (1) switch (_context26.n) {
        case 0:
          id = {
            docId: data.data.id
          };
          return _context26.a(2, request("/newDocument/editNewDocumentState", METHOD.POST, id));
      }
    }, _callee26);
  }));
  return _editNewDocumentState.apply(this, arguments);
}
export function editSystemNoticeState(_x33) {
  return _editSystemNoticeState.apply(this, arguments);
}

//打印
function _editSystemNoticeState() {
  _editSystemNoticeState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(data) {
    var id;
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.n) {
        case 0:
          id = {
            msgId: data.data.msgId,
            noticeType: data.data.type
          };
          return _context27.a(2, request("/systemNotice/editSystemNoticeState", METHOD.POST, id));
      }
    }, _callee27);
  }));
  return _editSystemNoticeState.apply(this, arguments);
}
export function printDocumentTemplate(_x34) {
  return _printDocumentTemplate.apply(this, arguments);
}
/**
 * 查询分发详情
 * 接口文档http://43.136.181.215:4999/web/#/48/3246
 */
function _printDocumentTemplate() {
  _printDocumentTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(data) {
    return _regenerator().w(function (_context28) {
      while (1) switch (_context28.n) {
        case 0:
          return _context28.a(2, request("/documentPrint/printDocumentTemplate", METHOD.POST, data));
      }
    }, _callee28);
  }));
  return _printDocumentTemplate.apply(this, arguments);
}
export function queryIssuedDet(_x35) {
  return _queryIssuedDet.apply(this, arguments);
}
/**
 * 查询分发查阅情况
 * 接口文档http://43.136.181.215:4999/web/#/48/3248
 */
function _queryIssuedDet() {
  _queryIssuedDet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(data) {
    return _regenerator().w(function (_context29) {
      while (1) switch (_context29.n) {
        case 0:
          return _context29.a(2, request("/docGather/queryIssuedDet", METHOD.POST, data));
      }
    }, _callee29);
  }));
  return _queryIssuedDet.apply(this, arguments);
}
export function queryIssuedCheckDet(_x36, _x37, _x38) {
  return _queryIssuedCheckDet.apply(this, arguments);
}
function _queryIssuedCheckDet() {
  _queryIssuedCheckDet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(page, limit, param) {
    var data;
    return _regenerator().w(function (_context30) {
      while (1) switch (_context30.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            mobile: param.mobile,
            queryStr: param.queryStr,
            docId: param.docId,
            type: param.type
          };
          return _context30.a(2, request("/docGather/queryIssuedCheckDet", METHOD.POST, data));
      }
    }, _callee30);
  }));
  return _queryIssuedCheckDet.apply(this, arguments);
}